import { Dialog, Classes, Button } from '@blueprintjs/core'

import React from 'react'
import css from './CheckinWithQRCodeModal.module.scss'
import QRCodeIcon from '@ui/icons/QRCodeIcon'

const CheckinWithQRCodeModal = ({ onHide }: { onHide: () => void }) => (
  <Dialog
    isOpen
    isCloseButtonShown={false}
    canOutsideClickClose={true}
    title="Check-in with QR code"
    onClose={onHide}
    className={css.middleModal}
  >
    <>
      <div className={Classes.DIALOG_BODY}>
        <div className={css.qrCodeSection}>
          <QRCodeIcon />
        </div>
        Use mobile to scan qr code to checkin. In case of any concerns, please contact your admin.
      </div>
      <div className={Classes.DIALOG_FOOTER}>
        <div className={css.footerLeftAlignContent}>
          <Button onClick={onHide}>Ok</Button>
        </div>
      </div>
    </>
  </Dialog>
)

export default CheckinWithQRCodeModal
